
import userQrcode from './userQrcode.vue' // 二维码
import userDealer from './userDealer.vue' // 交易商数据
import userSignin from './userSigin.vue' // 登录/注册
import userRegister from './userRegister.vue' // 邮箱注册/登录
import userReset from './userReset.vue' // 重置
import userMpopup from './userMpopup.vue' // m端登录弹框

import Newjoin from '~/components/service/Newjoin.vue'
export default {
  components: {
    'user-qrcode': userQrcode, // 二维码
    'user-dealer': userDealer, // 国家数据
    'user-sigin': userSignin, // 登录框
    'user-register': userRegister, // 邮箱注册/登录
    'user-reset': userReset, // 验证码
    'user-mpopup': userMpopup, // m端
    Newjoin
  },
  props: {
    closebtn: {
      // 关闭是否隐藏
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      mobile: false, // 是否为移动端
      signState: 1,
      loginCode: 1, // 1:登录/注册 2:重置密码/忘记密码
      email: '', // 邮箱
      isregister: false, // 邮箱是否注册
      isTo: false, // 是否跳转用户中心
      ismob: false // 是否触发过m端
    }
  },
  computed: {},
  created() {},
  mounted() {
    const _this = this
    _this.setIsMobile()
    window.addEventListener('resize', function () {
      _this.setIsMobile()
    })
  },
  methods: {
    setIsMobile() {
      if (document.documentElement.clientWidth > 799 - this.getScrollbarWidth()) {
        this.mobile = false
        if ((this.loginCode != 4 && this.loginCode == 1) || this.loginCode == 5) {
          this.ismob = false
          this.loginCode = 1
        }
      } else {
        this.mobile = true
        if (this.loginCode != 4 && !this.ismob && this.$route.query.type != 'register') {
          this.ismob = true
          this.loginCode = 5
        }
      }
    },
    getScrollbarWidth() {
      // 计算滚动条宽度
      const scrollDiv = document.createElement('div')
      scrollDiv.style.cssText = 'height: 99px; overflow: scroll; position: absolute; top: -9999px;'
      document.body.appendChild(scrollDiv)
      const scrollbarWidth = scrollDiv.offsetWidth - scrollDiv.clientWidth
      document.body.removeChild(scrollDiv)
      return scrollbarWidth
    },
    openlog(i) {
      console.log('i，弹框', i)
      this.isTo = i
      setTimeout(() => {
        if (!this.isTo) {
          this.tologin()
        }
      }, 500)
    },
    tologin() {
      this.close()
      if (this.$store.state.path.includes('login.html')) {
        // setTimeout(() => {
        if (process.client) window.open(`https://www.${this.$store.state.newhost}.${this.getSuffix(this.$store.state)}/${this.$store.state.LanguageCode}/`)
        // }, 200)
      }
    },
    loginSwitch(i) {
      // 切换状态
      this.loginCode = i
    },
    emailSwitch(i, email, isregister) {
      // 邮箱登录/注册
      this.loginCode = i
      this.email = email
      this.isregister = isregister
    },
    close() {
      if (this.$store.state.userlogin2) {
        const postdata = {
          op_type: 'close',
          url: '',
          parm: ''
        }
        window.parent && window.parent.postMessage(postdata, '*')
      } else {
        this.$store.commit('loginClose', false)
        // this.loginCode = 1 // 切换为账号/手机登录
        if (document.documentElement.clientWidth > 799) {
          this.mobile = false
          this.loginCode = 1
        } else {
          this.mobile = true
          this.loginCode = 5
        }
        // this.phone = this.verifCode = this.requestId = ''
        this.email = ''
        if (this.$store.state.path.includes('login.html')) {
          // setTimeout(() => {
          if (process.client) window.open(`https://www.${this.$store.state.newhost}.${this.getSuffix(this.$store.state)}/${this.$store.state.LanguageCode}/`)
          // }, 200)
        }
      }
    },
    back() {
      this.signState = 2
      this.loginCode = 1
    },
    popjoinflow() {
      console.log('加入')
      this.loginCode = 4
      if (this.$refs.Joinflow) this.$refs.Joinflow.open({}) // 加入/认领流程
    }
  }
}
